import { inject } from "vue";

export default function useCalendar(){

  const lang = inject('lang');
  const idioma = lang.value == "pt" ? "pt-PT" : "en-uk" ;

  const getNumberOfWeeks = (daysInMonth,firstDayOfMonth) => {
    const firstDayOfWeek = firstDayOfMonth.getDay() === 0 ? 7 : firstDayOfMonth.getDay();
    return Math.ceil((firstDayOfWeek + daysInMonth - 1) / 7);
  }

  const calculatePrevious3Months = (afterMinCalendarIndex,currentDate, yearlimit) => {
    const months = [];
    for (let i = 1; i <= 3; i++) {
      const fullYear = currentDate.getFullYear();
      const monthval = currentDate.getMonth() - i;
      const month = new Date(fullYear,monthval,1);
      const daysInMonth = new Date(fullYear,monthval + 1,0).getDate();
      const numberOfWeeks = getNumberOfWeeks(daysInMonth,month)
      if((yearlimit > -1 && month.getFullYear() >= yearlimit) || yearlimit == -1){
        months.unshift({
          name: month.toLocaleString(idioma, { month: "long" }),
          days: daysInMonth,
          month: month.toLocaleString(idioma, { month: "numeric" }),
          year: month.toLocaleString(idioma, { year: "numeric" }),
          numberOfWeeks: numberOfWeeks,
          index: afterMinCalendarIndex - 1 - i,
          first: month.getMonth() == 0 && yearlimit == month.getFullYear(),
          last:false
        }); 
      }
    }
    return months;
  }

  const calculateNext3Months = (beforeMaxCalendarIndex,currentDate,yearlimit) => {
    const months = [];
    for (let i = 1; i <= 3; i++) {
      const fullYear = currentDate.getFullYear();
      const monthval = currentDate.getMonth() + i;
      const month = new Date(fullYear,monthval,1);
      const daysInMonth = new Date(fullYear,monthval + 1,0).getDate();
      const numberOfWeeks = getNumberOfWeeks(daysInMonth,month)
      if((yearlimit > -1 && month.getFullYear() <= yearlimit) || yearlimit == -1){
        months.push({
          name: month.toLocaleString(idioma, { month: "long" }),
          days: daysInMonth,
          month: month.toLocaleString(idioma, { month: "numeric" }),
          year: month.toLocaleString(idioma, { year: "numeric" }),
          numberOfWeeks: numberOfWeeks,
          index: beforeMaxCalendarIndex + 1 + i,
        }); 
      }
    }
    return months;
  }

  const calculatePrevious3Years = (years) => {
    const currentYear = years[0].year;
    var years = [];
    for (let index = currentYear - 4; index < currentYear; index++) {
      years.push({
        year: index,
        months: getMonthsInYear(index),
      });
    }
    return years;
  }
  
  const calculateNext3Years = (years) => {
    const currentYear = years[years.length - 1].year;
    var years = [];
    for (let index = currentYear + 1; index < currentYear + 4; index++) {
      years.push({
        year: index,
        months: getMonthsInYear(index),
      });
    }
    return years;
  }

  const getMonthsInYear = (year) => {
    const months = [];
    for (let i = 0; i < 12; i++) {
      const month = new Date(year, i, 1);
      const daysInMonth = new Date(year, i + 1, 0).getDate();
      months.push({
        name: month.toLocaleString(idioma, { month: "long" }),
        days: daysInMonth,
        month: month.toLocaleString(idioma, { month: "numeric" }),
        year: month.toLocaleString(idioma, { year: "numeric" }),
      });
    }
    return months;
  }

  const calculateYearsInRange = (currentDate) => {
    const startYear = currentDate.getFullYear() - 2;
    const endYear = currentDate.getFullYear() + 2;
    const yearsInRange = [];
    for (let i = startYear; i <= endYear; i++) {
      yearsInRange.push({
        year: i,
        months: getMonthsInYear(i),
      });
    }
    return yearsInRange;
  }

  const calculateMonthsInRange = (currentDate) => {
    const months = [];
    for (let i = -3; i <= 3; i++) {
      const month = getMonthForDate(currentDate,i);
      const daysInMonth = getDaysInMonth(currentDate,i);
      const numberOfWeeks = getNumberOfWeeks(daysInMonth,month)
      months.push({
        name: month.toLocaleString(idioma, { month: "long" }),
        days: daysInMonth,
        month: month.toLocaleString(idioma, { month: "numeric" }),
        year: month.toLocaleString(idioma, { year: "numeric" }),
        numberOfWeeks: numberOfWeeks,
        index: i,
      });
    }
    return months;
  }

  const getMonthForDate = (currentDate,i) => {
    return new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + i,
        1
      );
  }

  const getDaysInMonth = (currentDate,i) => {
    return new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + i + 1,
        0
      ).getDate();
  }

  return {
    calculatePrevious3Months,
    calculateNext3Months,
    calculatePrevious3Years,
    calculateNext3Years,
    calculateYearsInRange,
    calculateMonthsInRange
  }

}